import type { Translate } from '@client-app/i18n';
import type { CloudAgentRunAuditRunView } from '@/view-models/cloud-agent-run-audit';

export const getRunActionSummary = (
    run: Pick<CloudAgentRunAuditRunView, 'readCount' | 'writeCount'>,
    t: Translate,
): string | null => (
    run.readCount === 0 && run.writeCount === 0
        ? null
        : t('website.auditLog.readWriteCount', { read: run.readCount, write: run.writeCount })
);
